const shoppingCatalog = [
  {
    id: 'bed-001',
    name: 'Modern King Size Bed',
    category: 'Bedroom',
    price: 24999,
    image: '/images/upvc-wardrobe.jpg',
    description: 'Strong, elegant bed frame for a comfortable bedroom.'
  },
  {
    id: 'cot-001',
    name: 'Ready-Made Palang',
    category: 'Bedroom',
    price: 14999,
    image: 'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=700&auto=format&fit=crop',
    description: 'Ready-to-use palang with a clean, space-saving design.'
  },
  {
    id: 'chair-001',
    name: 'Solid Wood Chair',
    category: 'Living Room',
    price: 2999,
    image: 'https://images.unsplash.com/photo-1503602642458-232111445657?w=700&auto=format&fit=crop',
    description: 'Comfortable everyday chair with durable furniture-grade finish.'
  },
  {
    id: 'table-001',
    name: 'Compact Dining Table',
    category: 'Living Room',
    price: 8999,
    image: 'https://images.unsplash.com/photo-1618220179428-22790b461013?w=700&auto=format&fit=crop',
    description: 'A practical table for dining, work or family gatherings.'
  },
  {
    id: 'cupboard-001',
    name: 'UPVC Storage Cupboard',
    category: 'UPVC Furniture',
    price: 11999,
    image: 'https://images.unsplash.com/photo-1595428774223-ef52624120d2?w=700&auto=format&fit=crop',
    description: 'Low-maintenance UPVC storage for bedrooms and halls.'
  },
  {
    id: 'kitchen-001',
    name: 'UPVC Kitchen Unit',
    category: 'UPVC Furniture',
    price: 32999,
    image: 'https://images.unsplash.com/photo-1556912167-f556f1f39fdf?w=700&auto=format&fit=crop',
    description: 'Durable UPVC kitchen storage designed for daily use.'
  }
];

export default shoppingCatalog;
